import React, { useEffect } from "react";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { CONSTANTS as C } from "config";
import { useGetOrderInfoByIdMutation } from "redux/Logistic/LogisticService";
import { UTILS } from "utils";
import AppTextArea from "components/ui/AppTextArea";
import AppButton from "components/ui/AppButton";
import AppOutlineButton from "components/ui/AppOutlineButton";

const OrderRejectForm = ({
  closeModal,
  rejectReason,
  handleValues,
  onSubmit,
  loading,
  order,
  handleErrors,
}) => {
  const { t } = useTranslation();
  const [getOrderInfoById] = useGetOrderInfoByIdMutation();
  const { orderInfo } = useSelector((state) => state.LogisticReducer);

  useEffect(() => {
    async function fetchOrderInfo() {
      try {
        await getOrderInfoById({
          brandId: UTILS.getCurrentUser().brandId,
          orderId: order?._id,
        });
      } catch (error) {
      } finally {
        if (orderInfo?.logisticPartner !== C.STORE) {
          handleErrors(
            "logisticPartner",
            t(
              "You have already sent a rider request to , so cancel it as well. Otherwise, you will be charged",
              {
                logisticPartner: orderInfo?.logisticPartner,
              }
            )
          );
        }
      }
    }
    fetchOrderInfo();
    return () => {
      handleErrors("logisticPartner", null);
    };
  }, [order?.logisticPartner, order?.orderNumber]);

  return (
    <Spin spinning={loading}>
      <div className="relative mx-auto my-auto w-full bg-white">
        <div>
          <div className="flex-auto justify-center my-2">
            <div className="pb-2 pt-4">
              <AppTextArea
                label={t("Reason")}
                value={rejectReason?.values?.reason}
                onInput={(e) => handleValues("reason", e.target.value)}
                required={true}
                error={rejectReason?.errors?.reason}
                rows={4}
              />
            </div>
            {/* PAYPAGE == PAYBY */}
            {(order?.orderCheckoutOnlinePaymentMetadata?.data?.paymentGateway ===
              "STRIPE" ||
              order?.orderCheckoutOnlinePaymentMetadata?.paySceneCode
               === "PAYPAGE" ||
               order?.orderCheckoutOnlinePaymentMetadata?.paymentProvider === "AFS_PAYMENT"
              || order?.orderCheckoutOnlinePaymentMetadata?.paymentGateway === "AFS_PAYMENT"
              || order?.orderCheckoutOnlinePaymentMetadata?.paymentGateway ===  "STRIPE"
              )
               && (
              <div className="px-4">
                <label className="inline-flex items-center gap-2 text-sm text-gray-700">
                  <input
                    type="checkbox"
                    className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                  checked={rejectReason?.values?.isRefundRequired}
                  onChange={(e) =>
                    handleValues("isRefundRequired", e.target.checked)
                  }
                  />
                  {t("Is Refundable")}
                </label>
              </div>
            )}
          </div>
          {rejectReason?.errors?.logisticPartner ? (
            <div className="text-red-500 px-4 font-semibold">
              {rejectReason?.errors?.logisticPartner}
            </div>
          ) : null}
          <div className="mt-4 flex justify-end gap-2 px-4">
            <AppOutlineButton onClick={closeModal}>
              {t("Close")}
            </AppOutlineButton>
            <AppButton
              variant="danger"
              onClick={() => onSubmit("CANCELLED", "REJECT")}
            >
              {rejectReason.values?.type === "REJECTED" && t("Reject")}
              {rejectReason.values?.type === "CANCELLED" && t("Cancel")}
            </AppButton>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default OrderRejectForm;
